/**
 * Smooth Scroll Module
 * Handles smooth scrolling for hash links
 */

export function initSmoothScroll() {
  // Get all links with hash
  const links = document.querySelectorAll('a[href^="#"], a[href*="/#"]');

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  links.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');

      // Extract the hash part
      let hash = href;
      if (href.includes('/#')) {
        hash = '#' + href.split('/#')[1];
      }

      // Skip if it's just "#" or empty
      if (!hash || hash === '#') return;

      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      // Update URL hash
      history.pushState(null, '', hash);

      // Scroll to target
      const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      if (prefersReducedMotion) {
        window.scrollTo(0, targetPosition);
      } else {
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }

      // Focus target for accessibility
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });

  // Handle initial hash on page load
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      // Delay to allow page to render
      setTimeout(() => {
        const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo(0, targetPosition);
      }, 100);
    }
  }
}
